<script lang="ts">
  let identifier = "";
  let email = "";
  let firstName = "";
  let lastName = "";
  let phone = "";
  let businessTitle = "";

  let result: string = "";
  let loading = false;

  const baseUrl = `${process.env.SVELTE_APP_REMOTE_URL}/api/alace/aws-partner-central`;

  const getOpportunity = async () => {
    if (!identifier.trim()) {
      result = "Please enter an Identifier.";
      return;
    }

    loading = true;
    result = "";

    try {
      const res = await fetch(`${baseUrl}/get-opportunity`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Identifier: identifier }),
      });
      const data = await res.json();
      result = JSON.stringify(data, null, 2);
    } catch (err: any) {
      result = "Error fetching opportunity: " + err.message;
    } finally {
      loading = false;
    }
  };

  const assignOpportunity = async () => {
    if (!identifier.trim() || !email.trim()) {
      result = "Identifier and Email are required.";
      return;
    }

    loading = true;
    result = "";

    try {
      const res = await fetch(`${baseUrl}/assign-opportunity`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          identifier,
          email,
          firstName,
          lastName,
          phone,
          businessTitle,
        }),
      });
      const data = await res.json();
      result = JSON.stringify(data, null, 2);
    } catch (err: any) {
      result = "Error assigning opportunity: " + err.message;
    } finally {
      loading = false;
    }
  };
</script>

<div class="mt-8 w-full rounded-lg border border-white/10 bg-[#24283a] p-5 text-white shadow-[0_18px_40px_rgba(0,0,0,0.18)]">
  <h2 class="mb-4 text-base font-bold tracking-[0.01em] text-white">AWS Opportunity Manager</h2>

  <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
    <input
      placeholder="Opportunity Identifier (e.g., opp-1234567890)"
      class="manager-input md:col-span-2 xl:col-span-3"
      bind:value={identifier}
    />
    <input placeholder="Email" class="manager-input" bind:value={email} />
    <input placeholder="First Name" class="manager-input" bind:value={firstName} />
    <input placeholder="Last Name" class="manager-input" bind:value={lastName} />
    <input placeholder="Phone" class="manager-input" bind:value={phone} />
    <input placeholder="Business Title" class="manager-input md:col-span-2" bind:value={businessTitle} />
  </div>

  <div class="mt-4 grid grid-cols-1 gap-3 sm:flex sm:flex-wrap">
    <button
      class="w-full rounded-md bg-[#34344a] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#3f4059] disabled:opacity-50 sm:w-auto"
      on:click={getOpportunity}
      disabled={loading}
    >
      {loading ? "Loading..." : "🔍 Get Opportunity"}
    </button>

    <button
      class="w-full rounded-md border border-white/15 bg-[#30344a] px-4 py-2 text-sm font-semibold text-slate-100 transition hover:bg-[#383d55] disabled:opacity-50 sm:w-auto"
      on:click={assignOpportunity}
      disabled={loading}
    >
      {loading ? "Assigning..." : "👤 Assign Opportunity"}
    </button>
  </div>

  {#if result}
    <div class="mt-5 max-h-80 overflow-auto rounded-md border border-white/10 bg-[#24283a] p-4 text-sm text-slate-100">
      <pre>{result}</pre>
    </div>
  {/if}
</div>

<style>
  .manager-input {
    min-height: 42px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid rgba(203, 213, 225, 0.28);
    background: #1f2334;
    color: #f8fafc;
    padding: 0.625rem 0.75rem;
    font-size: 0.875rem;
    outline: none;
    transition: border-color 150ms ease, box-shadow 150ms ease;
  }

  .manager-input::placeholder {
    color: #8f9bad;
  }

  .manager-input:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);
  }
</style>
